<ng-container *ngIf="isAuthenticated">
    <app-header></app-header>
    <section class="page-space">
        <div class="spinner-container" *ngIf="(isBpLoggedIn$ | async)===false; else ready">
            <mat-spinner></mat-spinner>
        </div>
        <ng-template #ready>
            <div class="homepage-section">
                <div class="homepage-box mat-drawer-container mat-sidenav-content mat-drawer-transition">
                    <div class="mat-drawer-content mat-sidenav-content">
                        <div class="space-content container">
                            <router-outlet></router-outlet>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </section>
</ng-container>